import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useCustomerGroupsSelector = () => useSelector((state: StateExtended) => state.customers?.customerGroups);

export const useCustomerFiltersSelector = () => useSelector((state: StateExtended) => state.customers?.filters || null);
